var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import get from "lodash/get";
import { connect } from "../../store/connect";
import { BookingFormPopup } from "../BookingFormPopup/BookingFormPopup";
import { updateCustomerId } from "../../store/actions";
import { useLocation } from "react-router";
import { ERoute } from "../../helpers/Routes";
import { getCustomerData, getCustomerEntities, getCustomerList } from "../../store/actions/response.actions";
import { useConfig } from "../../AppContext";
import pickBy from "lodash/pickBy";
import cancelToken from "../../cancelTokens";
import { useAdminSettingsListener } from "../Cart/cart.helpers";
import { getFirstTimespanId } from "../BookingForm/booking-form.helpers";
var adminBookingformPopupFactory = function () {
    var useShowBookingForm = function () {
        var pathName = useLocation().pathname;
        return ["/", ERoute.BOOKCART].includes(pathName);
    };
    var AdminBookingForm = function (_a) {
        var onClose = _a.onClose, getCustomerEntities = _a.getCustomerEntities, getCustomerList = _a.getCustomerList, updateCustomerId = _a.updateCustomerId, timespanId = _a.timespanId, hasCustomerData = _a.hasCustomerData, props = __rest(_a, ["onClose", "getCustomerEntities", "getCustomerList", "updateCustomerId", "timespanId", "hasCustomerData"]);
        useAdminSettingsListener();
        var bookingId = new URLSearchParams(useLocation().search).get("bookingId");
        var shouldShow = useShowBookingForm();
        var customerIdFromContext = useConfig("customerId")[0];
        var source = React.useMemo(function () { return cancelToken("customer_api_cancel_token", {}); }, []);
        var customerId = String(customerIdFromContext || props.customerId || '');
        var attributes = React.useRef(__assign(__assign({}, props.attributes), { bookingId: bookingId })).current;
        React.useEffect(function () {
            updateCustomerId(customerId);
        }, [customerId]);
        React.useEffect(function () {
            if (customerIdFromContext && hasCustomerData) {
                return;
            }
            getCustomerEntities(pickBy({ customerId: customerId, timespanId: timespanId }, Boolean));
        }, [customerIdFromContext, customerId]);
        React.useEffect(function () {
            if (customerIdFromContext) {
                return;
            }
            if (bookingId) {
                return;
            }
            getCustomerList({ customerId: customerId ? String(customerId) : "", timespanId: timespanId, });
        }, [customerIdFromContext, timespanId, bookingId]);
        if (!shouldShow)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(BookingFormPopup, __assign({ apiCancelToken: source, shouldShowContinueButton: true, showCustomerSearchAndSelect: !customerIdFromContext, showTimespanSearchAndSelect: true, buttonsWithIcon: true, timespanId: attributes.timespanId }, props, { attributes: attributes }))));
    };
    var mapStateToProps = function (state, ownProps) {
        var _a, _b, _c;
        return ({
            hasCustomerData: !!((_c = (_b = (ownProps.customerIdFromContext && ((_a = getCustomerData(state.responseReducer)) === null || _a === void 0 ? void 0 : _a.response))) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c[ownProps.customerIdFromContext]),
            customerId: ownProps.customerIdFromContext || String(get(state, "formReducer.forms." + ownProps.name + ".customerId", '')),
            timespanId: getFirstTimespanId(state, ownProps.name),
        });
    };
    return connect(mapStateToProps, { getCustomerEntities: getCustomerEntities, getCustomerList: getCustomerList, updateCustomerId: updateCustomerId })(AdminBookingForm);
};
export var AdminBookingForm = adminBookingformPopupFactory();
